import { province } from '../../mock-data/province.js'
import { district } from '../../mock-data/district.js'
import { subDistrict } from '../../mock-data/subDistrict.js'
import { zipCode } from '../../mock-data/zipCode.js'

const state = { 
    provinceData:null,
    districtData:null,
    subDistrictData:null,
    zipCodeData:null
}

const mutations = { 
    SET_PROVINCE:(state,payload)=>{ 
        state.provinceData = payload
    },
    SET_DISTRICT:(state,payload)=>{ 
        state.districtData = payload
    },
    SET_SUBDISTRICT:(state,payload)=>{ 
        state.subDistrictData = payload
    },
    SET_ZIPCODE:(state,payload)=>{ 
        state.zipCodeData = payload
    },
    SET_CHANGE_PROVINCE:(state,id)=>{ 
        const data = district
        const infoDistrict = data.filter(x => x.PROVINCE_ID == id)
        state.districtData = infoDistrict
    },
    SET_CHANGE_DISTRICT:(state,id)=>{ 
        const data = subDistrict
        const infoSubdistrict = data.filter(x => x.DISTRICT_ID == id)
        state.subDistrictData = infoSubdistrict
    },
    SET_CHANGE_SUBDISTRICT:(state,id)=>{ 
        const data = zipCode
        const infoZipCode = data.find(x => x.SUB_DISTRICT_ID == id)
        state.zipCodeData = infoZipCode ? infoZipCode.ZIPCODE : null
        // console.log("this is zip code :",state.zipCodeData);
    }
}

const actions =  { 
    getProvince:({commit})=>{ 
        const data = province
        commit("SET_PROVINCE",data)
    },
    getDistrict:({commit})=>{ 
        const data = district
        commit("SET_DISTRICT",data)
    },
    getSubDistrict:({commit})=>{ 
        const data = subDistrict
        commit("SET_SUBDISTRICT",data)
    },
    getZipCode({commit}){ 
        const data = zipCode
        commit("SET_ZIPCODE",data)
    },
    selectProvince:({commit},id)=>{ 
        commit("SET_CHANGE_PROVINCE",id)
    },
    selectDistrict:({commit},id)=>{ 
        commit("SET_CHANGE_DISTRICT",id)
    },
    selectSubDistrict:({commit},id)=>{ 
        commit("SET_CHANGE_SUBDISTRICT",id)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}